import { format } from 'date-fns';
import { config } from '../../api/config';
import { lt } from 'date-fns/locale';

export const formatMonthDate = date =>
  format(new Date(date), 'yyyy.MM', {
    locale: lt,
  });

export const formatDate = date =>
  format(new Date(date), config.DEFAULTS.dateFormat);

export const formatLocaleDate = (date, dateFormat = 'yyyy-MM-dd HH:mm') =>
  format(new Date(date), dateFormat, {
    locale: lt,
  });

export const formatMoney = amount => {
  let money = 0;

  if (amount) {
    money = amount / 100;
  }
  money = money.toLocaleString(config.DEFAULTS.locale, {
    style: 'currency',
    maximumFractionDigits: 3,
    currency: 'EUR',
  });

  return money;
};

export const formatTime = string => {
  return string;
};

export const formatSecondsToMinutes = seconds => {
  const minutes = new Date(seconds * 1000).toISOString().substr(14, 5);
  return minutes;
};

export const formatMoneyToCents = money => {
  let cents = +money;
  cents = cents * 100;
  cents = parseInt(cents);

  return cents;
};

export const formatFilename = base =>
  `${base} ${format(new Date(), 'yyyy-MM-dd')}`;

export const formatPercent = percent => {
  return `${percent * 100} %`;
};

export const getTimestamp = (date, time) => {
  const currentTimestamp = Date.now();

  if (!date) return currentTimestamp;

  const preparedTime = time ?? format(currentTimestamp, 'HH:mm');
  return new Date(`${date}T${preparedTime}`).getTime();
};

// create timestamp from Date & time
export const formatDateTime = (payload, time) => {
  const date = new Date(payload);

  if (time) {
    const [hours, minutes] = time.split(':');

    date.setHours(hours);
    date.setMinutes(minutes);
  }

  return date.getTime();
};

export const formatDateTimeFromUnix = value => {
  const date = format(new Date(value), config.DEFAULTS.dateFormat);
  const time = value
    ? new Date(value).toLocaleTimeString(config.DEFAULTS.locale, {
        hour: '2-digit',
        minute: '2-digit',
      })
    : null;
  return `${date} ${time}`;
};
